// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-tabs-__TabDashboard-module___container","content":"src-components-tabs-__TabDashboard-module___content","header":"src-components-tabs-__TabDashboard-module___header","body":"src-components-tabs-__TabDashboard-module___body"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tabs/TabDashboard.module.css
// module id = 448
// module chunks = 0